import { ArrowBack } from "@mui/icons-material";
import { Stack } from "@mui/material";
import { useContext } from "react";
import { Link } from "react-router-dom";
import UserContext from "../../../services/Context/UserContext";
import { txt } from "../../../services/translation";

export default function Back(){

    const { user } = useContext(UserContext)

    return (

        <div className="apply-back">

            {user &&
                <Link to="/courses">

                    <Stack direction="row" alignItems="center" spacing={1}>

                        <ArrowBack />

                        <span>{txt('catalog')}</span>

                    </Stack>

                </Link>
            }

        </div>
    );
}